import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import './index.css';

const styles = () => ({
  root: {
    width: '100%',
  },
});

const LabeledResource = ({
  bgColor, fontColor, title, subtitle, children,
}) => (
  <div
    className="labeled-resource"
    style={{
      backgroundColor: bgColor,
    }}
  >
    <span>
      <h2 style={{ color: fontColor, fontWeight: '300' }}>{title}</h2>
      <p style={{ color: fontColor }}>{subtitle}</p>
    </span>
    {children}
  </div>
);

LabeledResource.propTypes = {
  bgColor: PropTypes.string.isRequired,
  fontColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

function Resources({ classes }) {
  return (
    <div className={classes.root}>
      <LabeledResource
        bgColor="#19486a"
        title="Tools and Templates"
        fontColor="#FFFFFF"
        subtitle=""
      >
        <iframe
          title="tool and templates"
          className="airtable-embed"
          src="https://airtable.com/embed/shrkSkH3MBEpgTljO?backgroundColor=green&viewControls=on"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="750"
          style={{ background: 'transparent;', border: '1px solid #ccc;' }}
        />
      </LabeledResource>
      <LabeledResource
        bgColor="#eeeeee"
        fontColor="#19486a"
        title="Playbooks"
        subtitle=""
      >
        <iframe
          title="playbooks"
          className="airtable-embed"
          src="https://airtable.com/embed/shrT2ucYEFM4DpOah?backgroundColor=green&viewControls=on"
          frameBorder="0"
          onmousewheel=""
          width="100%"
          height="750"
          style={{ background: 'transparent;', border: '1px solid #ccc;' }}
        />
      </LabeledResource>
    </div>
  );
}

Resources.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Resources);
